/**
 * Route for `allowed-traffic`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AllowedTrafficPage } from "../features/allowed-traffic/AllowedTrafficPage";

export const allowedTrafficRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/allowed-traffic",
	component: AllowedTrafficPage,
});

export default allowedTrafficRoute;
